/**
 * "AI not in your plan" upsell (medopd-docs 126): a clinic or group admin asks ClinVea for the AI add-on,
 * and the super admin's queue of those requests.
 */
import { fetchApi } from '../client';
import type { PagedResponse } from '../../../types/pagination';

/** TEAM_ADMIN / TEAM_STAFF: an owner-doctor clinic asks for a clinic admin or staff (medopd-docs 148). */
export type AddonCode = 'AI_ASSISTANT' | 'WHATSAPP' | 'EXTRA_SEATS' | 'TEAM_ADMIN' | 'TEAM_STAFF';

export interface AddonRequestStatus {
  addon: AddonCode;
  moduleEnabled: boolean;
  requestedToday: boolean;
}

export interface AddonRequestResult {
  requested: boolean;
  /** true when the clinic already asked today — nothing new was sent. */
  alreadyRequested: boolean;
}

export interface AddonRequestView {
  id: string;
  clinicId: string;
  clinicName?: string | null;
  addon: AddonCode;
  requestedBy: string;
  requestedByName?: string | null;
  requestedOn: string;
  status: 'PENDING' | 'HANDLED';
  createdAt: string;
  handledAt?: string | null;
  /** Team requests: who the clinic wants added. */
  note?: string | null;
}

const CLINIC = '/api/clinic/addon-requests';
const ADMIN = '/api/admin/addon-requests';

export const addonRequestsModule = {
  status: (addon: AddonCode = 'AI_ASSISTANT') =>
    fetchApi<AddonRequestStatus>(`${CLINIC}/status?addon=${addon}`),
  request: (addon: AddonCode = 'AI_ASSISTANT') =>
    fetchApi<AddonRequestResult>(CLINIC, { method: 'POST', body: JSON.stringify({ addon }) }),
  admin: {
    list: (status: 'PENDING' | 'ALL', page: number, size: number) =>
      fetchApi<PagedResponse<AddonRequestView>>(`${ADMIN}?status=${status}&page=${page}&size=${size}`),
    markHandled: (id: string) =>
      fetchApi<AddonRequestView>(`${ADMIN}/${encodeURIComponent(id)}/handled`, { method: 'POST' }),
  },
};
